<template>
    <button
        aria-label="открыть видео"
        class="group relative flex aspect-square flex-col items-center justify-center rounded-12 bg-accent"
        @click="handleOpenModal">
        <span class="block w-full flex-1 px-1.5 pt-1">
            <span class="flex gap-1">
                <span
                    v-for="i in 5"
                    :key="i"
                    class="block aspect-square flex-1 rounded-2 bg-black first:rounded-tl-8 last:rounded-tr-8"></span>
            </span>
        </span>
        <picture class="aspect-video w-full">
            <source
                v-if="preview?.webp_url"
                type="image/webp"
                :srcset="getMediaLink(preview?.webp_url || '', 200) || ''" />
            <source
                v-else-if="!preview?.webp_url && !preview?.url"
                type="image/webp"
                srcset="/assets/images/ui/placeholder/webp/cromi.webp" />
            <img
                :alt="preview?.alt || 'video preview'"
                :src="
                    getMediaLink(preview?.url || '', 200) ||
                    '/assets/images/ui/placeholder/jpg-png/cromi.png'
                "
                class="aspect-video w-full" />
        </picture>
        <span class="block w-full flex-1 px-1.5 pt-1">
            <span class="flex gap-1">
                <span
                    v-for="i in 5"
                    :key="i"
                    class="block aspect-square flex-1 rounded-2 bg-black first:rounded-bl-8 last:rounded-br-8"></span>
            </span>
        </span>
        <PlaySvg
            class="absolute inset-1/2 size-9 -translate-x-1/2 -translate-y-1/2 text-accent group-hover:opacity-100" />
    </button>
</template>

<script setup lang="ts">
import { useModalStore } from '#imports'
import type { Image } from '~/types/global.types'

import PlaySvg from '../base-video/PlaySvg.vue'

const props = defineProps({
    link: {
        type: String as PropType<string>,
        required: true,
    },
    preview: {
        type: [Object, null] as PropType<Image | null>,
        default: null,
    },
})

const modalStore = useModalStore()

function handleOpenModal(): void {
    modalStore.setVideoLink(props.link)
    modalStore.open('video')
}
</script>
